module.exports = __webpack_public_path__ + "img/skinreader_QRcode.babddc18.png";